import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Stack,
  Grid,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import VSNTypography from "../../shared/VSNTypography";

const ChartTable = ({ data, pdf }) => {
  return (
    <Grid container spacing={4} pt={3}>
      <Grid item xl={pdf ? 12 : 6} lg={pdf ? 12 : 6} xs={12}>
        {data?.visual_activity ? (
          <TableContainer
            component={Paper}
            sx={{ backgroundColor: "var(--white)" }}
          >
            <Table sx={{ borderCollapse: "collapse" }}>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      backgroundColor: "#EAEDF0",
                      border: "1px solid #CDD0E1",
                      width: "20%",
                    }}
                    // rowSpan={2}
                  >
                    Visual Acuity
                  </TableCell>
                  <TableCell
                    sx={{
                      backgroundColor: "#EAEDF0",
                      border: "1px solid #CDD0E1",
                      textAlign: "center",
                    }}
                  >
                    Right
                  </TableCell>
                  <TableCell
                    sx={{
                      backgroundColor: "#EAEDF0",
                      border: "1px solid #CDD0E1",
                      textAlign: "center",
                    }}
                  >
                    Left
                  </TableCell>
                  <TableCell
                    sx={{
                      backgroundColor: "#EAEDF0",
                      border: "1px solid #CDD0E1",
                      textAlign: "center",
                    }}
                  >
                    Binocular
                  </TableCell>
                  <TableCell
                    sx={{
                      backgroundColor: "#EAEDF0",
                      border: "1px solid #CDD0E1",
                      textAlign: "center",
                    }}
                  >
                    Corrected
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell
                    sx={{
                      backgroundColor: "#EAEDF0",
                      border: "1px solid #CDD0E1",
                    }}
                  >
                    Near Acuity (13 in.)
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                  >
                    {data?.visual_activity?.near_acuity_right ?? 0}
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                  >
                    {data?.visual_activity?.near_acuity_left ?? 0}
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                  >
                    {data?.visual_activity?.near_acuity_binocular ?? 0}
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                  >
                    {data?.visual_activity?.near_acuity_corrected ?? ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    sx={{
                      backgroundColor: "#EAEDF0",
                      border: "1px solid #CDD0E1",
                    }}
                  >
                    Far Acuity (20 ft.)
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                  >
                    {data?.visual_activity?.far_acuity_right ?? 0}
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                  >
                    {data?.visual_activity?.far_acuity_left ?? 0}
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                  >
                    {data?.visual_activity?.far_acuity_binocular ?? 0}
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                  >
                    {data?.visual_activity?.far_acuity_corrected ?? ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    sx={{
                      backgroundColor: "#EAEDF0",
                      border: "1px solid #CDD0E1",
                    }}
                  >
                    Interpretation
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                    colSpan={4}
                  >
                    {data?.visual_activity?.visual_activity_interpretation}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <VSNTypography>No data available</VSNTypography>
        )}
      </Grid>

      <Grid item xl={pdf ? 12 : 6} lg={pdf ? 12 : 6} xs={12}>
        {data?.visual_field ? (
          <TableContainer
            component={Paper}
            sx={{ backgroundColor: "var(--white)" }}
          >
            <Table sx={{ borderCollapse: "collapse" }}>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      backgroundColor: "#EAEDF0",
                      border: "1px solid #CDD0E1",
                      width: "20%",
                    }}
                    // rowSpan={2}
                  >
                    Visual Field
                  </TableCell>
                  <TableCell
                    sx={{
                      backgroundColor: "#EAEDF0",
                      border: "1px solid #CDD0E1",
                      textAlign: "center",
                    }}
                    // rowSpan={2}
                    colSpan={3}
                  >
                    Right
                  </TableCell>
                  <TableCell
                    sx={{
                      backgroundColor: "#EAEDF0",
                      border: "1px solid #CDD0E1",
                      textAlign: "center",
                    }}
                    // rowSpan={2}
                    colSpan={3}
                  >
                    Left
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell
                    sx={{
                      backgroundColor: "#EAEDF0",
                      border: "1px solid #CDD0E1",
                    }}
                  >
                    Position
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                  >
                    {data?.visual_field?.position_right
                      ?.visual_field_right_10 ?? 0}
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                  >
                    {data?.visual_field?.position_right
                      ?.visual_field_right_20 ?? 0}
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                  >
                    {data?.visual_field?.position_right
                      ?.visual_field_right_30 ?? 0}
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                  >
                    {data?.visual_field?.position_left?.visual_field_left_10 ??
                      0}
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                  >
                    {data?.visual_field?.position_left?.visual_field_left_20 ??
                      0}
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                  >
                    {data?.visual_field?.position_left?.visual_field_left_30 ??
                      0}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    sx={{
                      backgroundColor: "#EAEDF0",
                      border: "1px solid #CDD0E1",
                    }}
                  >
                    Not Perceived
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                  >
                    {data?.visual_field?.not_perceived_right?.visual_field_1 ??
                      0}
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                  >
                    {data?.visual_field?.not_perceived_right?.visual_field_2 ??
                      0}
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                  >
                    {data?.visual_field?.not_perceived_right?.visual_field_3 ??
                      0}
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                  >
                    {data?.visual_field?.not_perceived_left?.visual_field_1 ??
                      0}
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                  >
                    {data?.visual_field?.not_perceived_left?.visual_field_1 ??
                      0}
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                  >
                    {data?.visual_field?.not_perceived_left?.visual_field_1 ??
                      0}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    sx={{
                      backgroundColor: "#EAEDF0",
                      border: "1px solid #CDD0E1",
                    }}
                  >
                    Interpretation
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                    colSpan={6}
                  >
                    {data?.visual_field?.visual_field_interpretation ?? ""}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <VSNTypography>No data available</VSNTypography>
        )}
      </Grid>
    </Grid>
  );
};

export const VisionChartTable = ({ data, title, name, pdf }) => {
  const isBoxNumberArray = Array?.isArray(data?.box_number);
  const boxEntries = isBoxNumberArray
    ? data?.box_number?.map((value, index) => [index, value])
    : Object.entries(data?.box_number);
  return (
    <Grid container spacing={4} pt={3}>
      <Grid item xl={12} lg={12} xs={12}>
        <VSNTypography sx={{ fontSize: "18px", fontWeight: 700, mb: 1 }}>
          {title ?? ""}
        </VSNTypography>

        {data?.box_number ? (
          <TableContainer
            component={Paper}
            sx={{
              transform: pdf ? "scale(0.9)" : "",
              transformOrigin: "top left",
              width: pdf ? "760px" : "100%",
            }}
          >
            <Table sx={{ borderCollapse: "collapse", width: "100%" }}>
              <TableBody>
                <TableRow>
                  <TableCell
                    sx={{
                      backgroundColor: "#EAEDF0",
                      border: "1px solid #CDD0E1",
                    }}
                  >
                    {name ?? "Number"}
                  </TableCell>
                  {boxEntries?.map(([key, value], index) => (
                    <TableCell
                      key={index}
                      sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                    >
                      {Array.isArray(value) ? (
                        <Stack
                          direction="row"
                          justifyContent="space-between"
                          px={pdf ? 0 : 4}
                        >
                          {value?.map((num, idx) => (
                            <VSNTypography key={idx}>{num}</VSNTypography>
                          ))}
                        </Stack>
                      ) : (
                        <VSNTypography>{value}</VSNTypography>
                      )}
                    </TableCell>
                  ))}
                </TableRow>

                <TableRow>
                  <TableCell
                    sx={{
                      backgroundColor: "#EAEDF0",
                      border: "1px solid #CDD0E1",
                    }}
                  >
                    Correct
                  </TableCell>
                  {boxEntries?.map(([key, value], index) => {
                    if (Array.isArray(data?.correct)) {
                      const isCorrect = data?.correct[index];
                      return (
                        <TableCell
                          key={index}
                          sx={{
                            border: "1px solid #CDD0E1",
                            textAlign: "center",
                          }}
                        >
                          {isCorrect ? (
                            <CheckIcon
                              fontSize="small"
                              style={{ color: "var(--green)" }}
                            />
                          ) : (
                            <CloseIcon
                              fontSize="small"
                              style={{ color: "red" }}
                            />
                          )}
                        </TableCell>
                      );
                    }
                    const correctKey = `color_perception_${key}`;
                    const isCorrect = data?.correct[correctKey];
                    return (
                      <TableCell
                        key={index}
                        sx={{
                          border: "1px solid #CDD0E1",
                          textAlign: "center",
                        }}
                      >
                        {Array.isArray(value) ? (
                          <Stack
                            direction="row"
                            px={pdf ? 0 : 4}
                            justifyContent="space-between"
                          >
                            {value?.map((_, i) =>
                              isCorrect ? (
                                <CheckIcon
                                  key={i}
                                  fontSize="small"
                                  style={{ color: "var(--green)" }}
                                />
                              ) : (
                                <CloseIcon
                                  key={i}
                                  fontSize="small"
                                  style={{ color: "red" }}
                                />
                              )
                            )}
                          </Stack>
                        ) : isCorrect ? (
                          <CheckIcon
                            fontSize="small"
                            style={{ color: "var(--green)" }}
                          />
                        ) : (
                          <CloseIcon
                            fontSize="small"
                            style={{ color: "red" }}
                          />
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>

                {/* Interpretation Row */}
                <TableRow>
                  <TableCell
                    sx={{
                      backgroundColor: "#EAEDF0",
                      border: "1px solid #CDD0E1",
                    }}
                  >
                    Interpretation
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                    colSpan={boxEntries?.length}
                  >
                    {data?.interpretation ?? ""}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <VSNTypography>No data available</VSNTypography>
        )}
      </Grid>
    </Grid>
  );
};

export const HeartRateAndBloodPressureTable = ({ data, pdf }) => {
  return (
    <Grid container spacing={4} pt={3}>
      <Grid item xl={pdf ? 12 : 12} lg={pdf ? 12 : 12} xs={12}>
        {data?.diastolic ? (
          <TableContainer
            component={Paper}
            sx={{ backgroundColor: "var(--white)" }}
          >
            <Table sx={{ borderCollapse: "collapse" }}>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      backgroundColor: "#EAEDF0",
                      border: "1px solid #CDD0E1",
                      width: "20%",
                    }}
                  >
                    {" "}
                  </TableCell>
                  <TableCell
                    sx={{
                      backgroundColor: "#EAEDF0",
                      border: "1px solid #CDD0E1",
                      textAlign: "center",
                      fontWeight: 700,
                    }}
                  >
                    Measurement #1
                  </TableCell>
                  <TableCell
                    sx={{
                      backgroundColor: "#EAEDF0",
                      border: "1px solid #CDD0E1",
                      textAlign: "center",
                      fontWeight: 700,
                    }}
                  >
                    Measurement #2
                  </TableCell>
                  <TableCell
                    sx={{
                      backgroundColor: "#EAEDF0",
                      border: "1px solid #CDD0E1",
                      textAlign: "center",
                      fontWeight: 700,
                    }}
                  >
                    Measurement #3
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell
                    sx={{
                      backgroundColor: "#EAEDF0",
                      border: "1px solid #CDD0E1",
                      textAlign: "center",
                      fontWeight: 700,
                    }}
                  >
                    Heart Rate
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                  >
                    {data?.heart_rate?.measurement_1 ?? 0}
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                  >
                    {data?.heart_rate?.measurement_2 ?? 0}
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                  >
                    {data?.heart_rate?.measurement_3 ?? 0}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    sx={{
                      backgroundColor: "#EAEDF0",
                      border: "1px solid #CDD0E1",
                      textAlign: "center",
                      fontWeight: 700,
                    }}
                  >
                    Systolic
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                  >
                    {data?.systolic?.measurement_1 ?? 0}
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                  >
                    {data?.systolic?.measurement_2 ?? 0}
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                  >
                    {data?.systolic?.measurement_3 ?? 0}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    sx={{
                      backgroundColor: "#EAEDF0",
                      border: "1px solid #CDD0E1",
                      textAlign: "center",
                      fontWeight: 700,
                    }}
                  >
                    Diastolic
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                  >
                    {data?.diastolic?.measurement_1 ?? 0}
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                  >
                    {data?.diastolic?.measurement_2 ?? 0}
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}
                  >
                    {data?.diastolic?.measurement_3 ?? 0}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <VSNTypography>No data available</VSNTypography>
        )}
      </Grid>
    </Grid>
  );
};

export const AudioGramTable = ({ data, color, height }) => (
  <TableContainer
    // component={Paper}
    sx={{
      backgroundColor: "transparent",
      "& td": { backgroundColor: "var(--white)" },
      height,
    }}
  >
    <Table sx={{ borderCollapse: "collapse", borderRadius: 4 }}>
      <TableHead>
        <TableRow>
          <TableCell
            sx={{
              backgroundColor: "#EAEDF0",
              border: "1px solid #CDD0E1",
              width: "20%",
            }}
            // rowSpan={2}
          >
            Frequency (Hz)
          </TableCell>
          <TableCell
            sx={{
              backgroundColor: "#EAEDF0",
              border: "1px solid #CDD0E1",
              textAlign: "center",
            }}
          >
            500
          </TableCell>
          <TableCell
            sx={{
              backgroundColor: "#EAEDF0",
              border: "1px solid #CDD0E1",
              textAlign: "center",
            }}
          >
            1000
          </TableCell>
          <TableCell
            sx={{
              backgroundColor: "#EAEDF0",
              border: "1px solid #CDD0E1",
              textAlign: "center",
            }}
          >
            2000
          </TableCell>
          <TableCell
            sx={{
              backgroundColor: "#EAEDF0",
              border: "1px solid #CDD0E1",
              textAlign: "center",
            }}
          >
            3000
          </TableCell>
          <TableCell
            sx={{
              backgroundColor: "#EAEDF0",
              border: "1px solid #CDD0E1",
              textAlign: "center",
            }}
          >
            4000
          </TableCell>
          <TableCell
            sx={{
              backgroundColor: "#EAEDF0",
              border: "1px solid #CDD0E1",
              textAlign: "center",
            }}
          >
            6000
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell
            sx={{
              backgroundColor: "#EAEDF0 !important",
              border: "1px solid #CDD0E1",
            }}
          >
            Baseline (dB)
          </TableCell>
          <TableCell sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}>
            15
          </TableCell>
          <TableCell sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}>
            5
          </TableCell>
          <TableCell sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}>
            5
          </TableCell>
          <TableCell sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}>
            20
          </TableCell>
          <TableCell sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}>
            10
          </TableCell>
          <TableCell sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}>
            35
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell
            sx={{
              backgroundColor: "#EAEDF0 !important",
              border: "1px solid #CDD0E1",
            }}
          >
            Current (dB)
          </TableCell>
          <TableCell
            sx={{
              border: "1px solid #CDD0E1",
              textAlign: "center",
              // color: color ? "" : "#F54346",
            }}
          >
            {data?.current?.audiogram_500 ?? 0}
          </TableCell>
          <TableCell
            sx={{
              border: "1px solid #CDD0E1",
              textAlign: "center",
              // color: color ? "" : "#F54346",
            }}
          >
            {data?.current?.audiogram_1000 ?? 0}
          </TableCell>
          <TableCell
            sx={{
              border: "1px solid #CDD0E1",
              textAlign: "center",
              // color: color ? "" : "#F54346",
            }}
          >
            {data?.current?.audiogram_2000 ?? 0}
          </TableCell>
          <TableCell
            sx={{
              border: "1px solid #CDD0E1",
              textAlign: "center",
              // color: color ? "" : "#F54346",
            }}
          >
            {data?.current?.audiogram_3000 ?? 0}
          </TableCell>
          <TableCell
            sx={{
              border: "1px solid #CDD0E1",
              textAlign: "center",
              // color: color ? "" : "#F54346",
            }}
          >
            {data?.current?.audiogram_4000 ?? 0}
          </TableCell>
          <TableCell
            sx={{
              border: "1px solid #CDD0E1",
              textAlign: "center",
              // color: color ? "" : "#F54346",
            }}
          >
            {data?.current?.audiogram_6000 ?? 0}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell
            sx={{
              backgroundColor: "#EAEDF0 !important",
              border: "1px solid #CDD0E1",
            }}
          >
            Delta (dB)
          </TableCell>
          <TableCell sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}>
            {data?.delta?.audiogram_500 ?? 0}
          </TableCell>
          <TableCell sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}>
            {data?.delta?.audiogram_1000 ?? 0}
          </TableCell>
          <TableCell sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}>
            {data?.delta?.audiogram_2000 ?? 0}
          </TableCell>
          <TableCell sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}>
            {data?.delta?.audiogram_3000 ?? 0}
          </TableCell>
          <TableCell sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}>
            {data?.delta?.audiogram_4000 ?? 0}
          </TableCell>
          <TableCell sx={{ border: "1px solid #CDD0E1", textAlign: "center" }}>
            {data?.delta?.audiogram_6000 ?? 0}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell
            sx={{
              backgroundColor: "#EAEDF0 !important",
              border: "1px solid #CDD0E1",
            }}
          >
            Average (dB)
          </TableCell>
          <TableCell
            sx={{
              border: "1px solid #CDD0E1",
              textAlign: "center",
              // color: color ? "" : "#F54346",
            }}
            colSpan={4}
          >
            {data?.average ?? 0}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  </TableContainer>
);

export default ChartTable;
